import { IUsuarioLogado } from "@/interfaces/IUsuarioLogado";
import { api } from "@/services/api";
import { usuarioLogadoAction } from "@/store/actions/usuarioLogado";
import { getUser } from "@/store/reducers/usuarioLogado";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useUsuarioLogado = () => {
  const { user } = useAuth();
  const appDispatch = useDispatch();
  const usuarioLogado = useSelector(getUser);
  const { add, remove } = usuarioLogadoAction;

  const removeUsuarioLogado = () => {
    appDispatch(remove());
  };

  const sincronizarUsuarioLogado = (usuario: IUsuarioLogado) => {
    appDispatch(add(usuario));
  };

  const getUsuarioLogadoApi = async () => {
    const { data } = await api.get<IUsuarioLogado>(`/usuarios/me`, {
      headers: {
        Authorization: `Bearer ${user?.access_token}`,
      },
    });
    return data;
  };

  return {
    usuarioLogado,
    sincronizarUsuarioLogado,
    removeUsuarioLogado,
    getUsuarioLogadoApi,
  };
};
